import { Box, Grid, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { BreadcrumbComponent } from '../components/BreadcrumbComponent/BreadcrumbComponent';
import { ImageCardComponent } from '../components/ImageCardComponent/ImageCardComponent';
import Content from '../components/Layout/Content';
import doctor from '../assests/doctor.svg';
import provider from '../assests/provider.svg';
import { Link } from 'react-router-dom';
import {
  dateParse_appointment,
  formatAppointments,
  formatDateInMMDDYYYYWithComma,
  formatTimeInHHMMWithComma,
  getContrastYIQ,
  getMedicalHistoryDataFromExtensions,
  handleStatusFilter,
  handleTimeFilter,
  searchDataByKey,
  TimeSlotArrayConvertor,
} from '../shared/helper';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import PersonIcon from '@mui/icons-material/Person';
import SecondaryBtnComponent from '../components/buttonComponent/SecondaryBtnComponent';
import SearchBar from '../components/SearchBar/Search';
import FilterDropDown from '../components/filterDropDown/FilterDropDown';
import {
  AppointmentStatusFilterData,
  APPOINTMENT_TYPES,
  DEFAULT_NULL_REPLACEMENT,
  APPOINTMENT_SCHEDULE_DETAILS,
  dateFilterMenuItems,
} from '../shared/constants';
import ReusableTable from '../components/ReusableTable/ReusableTable';
import BtnComponent from '../components/buttonComponent/BtnComponent';
import { BottomDrawerComponent } from '../components/BottomDrawerComponent/BottomDrawerComponent';
import { DrawerBoxComponent } from '../components/DrawerBoxComponent/DrawerBoxComponent';
import { AppointmentProviderInfo } from '../components/AppointmentComponents/AppointmentProviderInfo';
import { AppointmentVisitDetailsSummary } from '../components/AppointmentComponents/AppointmentVisitDetailsSummary';
import { AppointmentDateTimeSummary } from '../components/AppointmentComponents/AppointmentDateTimeSummary';
import { AppointmentVisitLink } from '../components/AppointmentComponents/AppointmentVisitLink';
import { AppointmentMedicalHistory } from '../components/AppointmentComponents/AppointmentMedicalHistory';
import { AppointmentPaymentDetails } from '../components/AppointmentComponents/AppointmentPaymentDetails';
import { AppointmentVisitStatus } from '../components/AppointmentComponents/AppointmentVisitStatus';
import { AppointmentReshedule } from '../components/AppointmentComponents/AppointmentReschedule';
import {
  FETCH_ALL_APPOINTMENTS_QUERY,
  FETCH_APPOINTMENT_BY_ID,
} from '../services/AppointmentQueries/AppointmentService';
import { useLazyQuery, useQuery } from '@apollo/client';
import { useSnackbar } from 'notistack';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
import NotFound from '../components/NotFound/NotFoundPage';
import { FETCH_ALL_VIRTUAL_VISIT_QUERY } from '../services/UpcomingCardsService/UpcomingCardService';
import ApplicationContext from '../context/applicationContext';
import ConfirmationModal from '../components/ConfirmationModal/ConfirmationModal';
import { useLocation } from 'react-router-dom';
import { FETCH_TIME_SLOT_QUERY } from '../services/ProvidersQueries/ProvidersService';
import {
  APPOINTMENTS,
  APPOINTMENTS_TABLE_HEADING as tableHeading,
  APPOINTMENTS_BREADCRUMBDATA as breadcrumbData,
} from '../shared/Strings';

const boxContainer = {
  position: 'relative',
  display: 'flex',
  flexWrap: 'wrap',
  top: 40,
  flex: 1,
};

const table = {
  marginTop: 8,
  '& .css-1kn3lhz': {},
};

const JoinVisit = ({
  color,
  date,
  provider,
  visitLink,
  isLinkEnabled = false,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mt: 2 }}>
      <Grid container direction="row">
        <Grid item>
          <AccessAlarmIcon fontSize="small" sx={{ color: color }} />
        </Grid>
        <Grid item>
          <Typography sx={{ ml: 1 }} color={color} variant="h6">
            {date}
          </Typography>
        </Grid>
      </Grid>
      <Grid container direction="row" sx={{ mt: 1 }}>
        <Grid item>
          <PersonIcon fontSize="small" sx={{ color: color }} />
        </Grid>
        <Grid item>
          <Typography sx={{ ml: 1 }} color={color} variant="h6">
            {provider}
          </Typography>
        </Grid>
      </Grid>
      <SecondaryBtnComponent
        sx={{
          mt: '15px',
          width: '118px',
          height: '40px',
          '&:hover': { bgcolor: 'white' },
        }}
        title={APPOINTMENTS.BUTTON_TEXT.JOIN_VISIT}
        target="_blank"
        href={visitLink}
        disabled={!isLinkEnabled}
      />
    </Box>
  );
};

const AppointmentDetailsPage = ({
  providerName,
  providerDetails,
  medicalHistoryData,
  visitDescription,
  getFinalPopUpData,
  handleClickOpen,
  timeslot,
  setShowPage,
  visitReason,
}) => {
  React.useEffect(() => {
    return () => {
      setShowPage(true);
    };
  }, [setShowPage]);
  return (
    <>
      <Grid container direction="column">
        <Grid item>
          <AppointmentProviderInfo
            providerName={providerName}
            providerDetails={providerDetails}
          />
        </Grid>
        <Grid item>
          <AppointmentVisitDetailsSummary
            visitDescription={visitDescription}
            visitReason={visitReason}
          />
        </Grid>
        <Grid item>
          <AppointmentMedicalHistory data={medicalHistoryData} />
        </Grid>
        <Grid item>
          <AppointmentReshedule
            timeslot={timeslot}
            getFinalPopUpData={getFinalPopUpData}
          />
        </Grid>
        <Grid item>
          <DrawerBoxComponent sx={{ bgcolor: 'inherit', pl: 1 }}>
            <Grid container spacing={2}>
              <Grid item>
                <SecondaryBtnComponent
                  title={APPOINTMENTS.BUTTON_TEXT.CANCEL_VISIT}
                  name="Cancel"
                  disabled={false}
                  onClick={handleClickOpen}
                />
              </Grid>
              <Grid item>
                <BtnComponent
                  title={APPOINTMENTS.BUTTON_TEXT.RESCHEDULE_VISIT}
                  name="Success"
                  onClick={handleClickOpen}
                  disabled={false}
                />
              </Grid>
            </Grid>
          </DrawerBoxComponent>
        </Grid>
      </Grid>
    </>
  );
};

const AppointmentDetails = ({
  providerName,
  providerDetails,
  setShowPage,
  visitDescription,
  dateTime,
  visitLink,
  medicalHistoryData,
  amount,
  paymentStatus,
  paymentID,
  appointmentStatus,
  setShowModal,
  visitReason,
}) => {
  const handleRedirection = () => {
    setShowPage(false);
  };
  const handledirection = () => {
    setShowModal(false);
  };
  return (
    <>
      <Grid container direction="column">
        <Grid item>
          <AppointmentProviderInfo
            providerName={providerName}
            providerDetails={providerDetails}
          />
        </Grid>
        <Grid item>
          <AppointmentVisitDetailsSummary
            visitDescription={visitDescription}
            visitReason={visitReason}
          />
        </Grid>
        <Grid item>
          <AppointmentDateTimeSummary dateTime={dateTime} />
        </Grid>
        {appointmentStatus === 'Cancelled' ? (
          <Grid item>
            <AppointmentVisitStatus
              visitStatus={appointmentStatus}
              refundStatus="Initiated"
            />
          </Grid>
        ) : (
          <Grid item>
            <AppointmentVisitLink visitLink={visitLink} />
          </Grid>
        )}
        <Grid item>
          <AppointmentMedicalHistory data={medicalHistoryData} />
        </Grid>
        <Grid item>
          <AppointmentPaymentDetails
            amount={amount}
            status={paymentStatus}
            paymentID={paymentID}
          />
          <Grid item>
            <DrawerBoxComponent sx={{ bgcolor: 'inherit', pl: 0 }}>
              {appointmentStatus !== 'Cancelled' ? (
                <Grid container spacing={2}>
                  <Grid item>
                    <SecondaryBtnComponent
                      title={APPOINTMENTS.BUTTON_TEXT.CANCEL_VISIT}
                      disabled={true}
                      onClick={handledirection}
                    />
                  </Grid>
                  <Grid item>
                    <BtnComponent
                      title={APPOINTMENTS.BUTTON_TEXT.RESCHEDULE_VISIT}
                      onClick={handleRedirection}
                      disabled={false}
                    />
                  </Grid>
                </Grid>
              ) : (
                <BtnComponent
                  title={APPOINTMENTS.BUTTON_TEXT.REFUND_DETAILS}
                  disabled={true}
                />
              )}
            </DrawerBoxComponent>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

const ScheduleVisit = ({ color, description }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mt: 2 }}>
      <Typography variant="h6" color={color}>
        {description}
      </Typography>
      <SecondaryBtnComponent
        sx={{
          mt: '15px',
          width: '170px',
          height: '32px',
          '&:hover': { bgcolor: 'white' },
        }}
        component={Link}
        to={'/care/findCare'}
        title={APPOINTMENTS.SCHEDULE_VISIT_TEXT}
        disabled={false}></SecondaryBtnComponent>
    </Box>
  );
};

export const Appointments = () => {
  const { state } = useLocation();
  const [searchValue, setSearchValue] = useState('');
  const [timeFilter, setTimeFilter] = useState('all');
  const [visitType, setVisitType] = useState('all visits');
  const [statusFilter, setStatusFilter] = useState('all');
  const [filteredData, setFilteredData] = useState([]);
  const [recordsData, setRecordedData] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedTableId, setSelectedTableId] = useState(null);
  const [upcomingAppointmentDate, setUpcomingAppointmentDate] = useState(null);
  const [upcomingProvider, setUpcomingProvider] = useState(null);
  const [showpage, setShowPage] = useState(true);
  const [popUpData, setPopUpData] = useState({});
  const [timeslot, setTimeSlot] = useState();
  const [directOpenFlyout, setDirectOpenFlyout] = useState(false);
  const [isOpen, setIsOpen] = useState({
    successModalOpen: false,
    cancelModalOpen: false,
  });
  const { enqueueSnackbar } = useSnackbar();
  const { appointmentsBanner } = useContext(ApplicationContext);
  const upcomingAppointments = useQuery(FETCH_ALL_VIRTUAL_VISIT_QUERY, {
    variables: { sourceUrl: '' },
  });

  const handleClickOpen = e => {
    if (e.target.name === 'Success' && popUpData.date && popUpData.startTime) {
      setIsOpen({
        successModalOpen: true,
        cancelModalOpen: false,
      });
      setDrawerOpen(false);
    } else if (e.target.name === 'Cancel') {
      setIsOpen({
        successModalOpen: false,
        cancelModalOpen: true,
      });
      setDrawerOpen(false);
    } else {
      setIsOpen({
        successModalOpen: false,
        cancelModalOpen: false,
      });
    }
  };

  useEffect(() => {
    if (recordsData.length !== 0 && state !== null) {
      let selectedData = recordsData.find(obj => obj.status === state);
      viewDetailsHandler(selectedData.id);
    }
  }, [recordsData, state]);

  const handleClose = () => {
    setIsOpen({
      successModalOpen: false,
      cancelModalOpen: false,
    });
  };

  const allAppointments = useQuery(FETCH_ALL_APPOINTMENTS_QUERY, {
    onError: err => {
      enqueueSnackbar(APPOINTMENTS.ON_ERROR_TEXT.WENT_WRONG_TEXT, {
        variant: 'error',
      });
    },
    onCompleted: res => {
      if (directOpenFlyout) {
        viewDetailsHandler(state.id);
      }
    },
  });
  useEffect(() => {
    if (state?.id) {
      setDirectOpenFlyout(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);
  const [fetchAppointmentById, fetchAppointmentByIdCall] = useLazyQuery(
    FETCH_APPOINTMENT_BY_ID,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(APPOINTMENTS.ON_ERROR_TEXT.BY_ID, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        //show data
        showDrawer(res.fetchAppointmentsById);
      },
    }
  );

  const [fetchSlotByPractitionerId, fetchSlotByPractitionerIdCall] =
    useLazyQuery(FETCH_TIME_SLOT_QUERY, {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(
          APPOINTMENTS.ON_ERROR_TEXT.WENT_WRONG_FETCHING_TIME_SLOT_TEXT,
          {
            variant: 'error',
          }
        );
      },
      onCompleted: res => {
        //show data
        const timeslot = TimeSlotArrayConvertor(res.fetchSlotByPractitionerId);
        setTimeSlot(timeslot);
      },
    });

  useEffect(() => {
    if (allAppointments.data) {
      let result = allAppointments?.data?.fetchAllAppointments;
      let data = formatAppointments(result);
      setRecordedData(data);
      setFilteredData(data);
    }
  }, [allAppointments.data]);

  useEffect(() => {
    if (upcomingAppointments.data) {
      const result = JSON.parse(
        upcomingAppointments?.data?.fetchUpCommingAppointments
          ?.appointmentResource
      );
      const date =
        formatDateInMMDDYYYYWithComma(result?.start) ||
        DEFAULT_NULL_REPLACEMENT;
      const time =
        formatTimeInHHMMWithComma(result?.start) || DEFAULT_NULL_REPLACEMENT;
      const dateTime = `${date} ${time}`;
      const providerName = result?.participant
        ? result?.participant[0].actor.display
        : DEFAULT_NULL_REPLACEMENT;
      setUpcomingAppointmentDate(dateTime);
      setUpcomingProvider(providerName);
    }
  }, [upcomingAppointments.data]);

  const [appointmentDetails, setAppointmentDetails] = useState({
    providerName: null,
    providerDetails: null,
    visitDescription: null,
    visitReason: null,
    dateTime: null,
    visitLink: null,
    medicalHistoryData: null,
    amount: null,
    paymentStatus: null,
    paymentID: null,
    appointmentStatus: null,
  });

  const dateFilterOptions = {
    options: dateFilterMenuItems,
    value: timeFilter,
    changeHandler: ev => {
      setTimeFilter(ev.target.value);
    },
  };

  const visitTypeFilterOptions = {
    options: APPOINTMENT_TYPES,
    value: visitType,
    changeHandler: ev => {
      setVisitType(ev.target.value);
    },
  };

  const statusFilterOptions = {
    options: AppointmentStatusFilterData,
    value: statusFilter,
    changeHandler: ev => {
      setStatusFilter(ev.target.value);
    },
  };

  const onSearch = text => {
    setSearchValue(text);
  };

  const showDrawer = result => {
    const res = JSON.parse(result.appointmentResource);

    //console.log(res.reasonCode[0].text);
    const tableRowInfo = recordsData.find(obj => obj.id === selectedTableId);
    const appointmentData = {
      providerName: res?.participant?.[0]?.actor?.display,
      appointmentStatus: tableRowInfo.status,
      providerDetails: res?.serviceType?.[0]?.text ?? DEFAULT_NULL_REPLACEMENT,
      visitDescription:
        tableRowInfo.typeOfVisitValue ?? DEFAULT_NULL_REPLACEMENT,

      visitDescription: tableRowInfo.typeOfVisitValue,
      visitReason: res?.reasonCode?.[0]?.text,
      dateTime: tableRowInfo.dateTime,
      visitLink: null,
      medicalHistoryData: getMedicalHistoryDataFromExtensions(res?.extension),
      amount: '$70',
      paymentStatus: 'Paid',
      paymentID: '134245526662',
    };

    setAppointmentDetails(oldData => {
      return { ...oldData, ...appointmentData };
    });
    setDrawerOpen(true);
  };

  const handleVisitTypeFilter = (filterVal, key, totalData) => {
    const searchedText = filterVal.toLocaleLowerCase();

    if (searchedText === 'all visits') {
      return totalData;
    }
    // eslint-disable-next-line array-callback-return
    return totalData.filter(obj => {
      if (obj[key]) {
        return obj[key].toLowerCase().includes(searchedText);
      }
    });
  };

  useEffect(() => {
    const timeFilteredData = handleTimeFilter(
      timeFilter,
      recordsData,
      'recordedOn'
    );
    const visitTypeFilteredData = handleVisitTypeFilter(
      visitType,
      'typeOfVisitValue',
      timeFilteredData
    );
    const statusFilteredData = handleStatusFilter(
      statusFilter,
      visitTypeFilteredData,
      AppointmentStatusFilterData
    );
    const searchData = searchDataByKey(
      statusFilteredData,
      'typeOfVisitValue',
      searchValue
    );
    setFilteredData(searchData);
  }, [timeFilter, visitType, statusFilter, searchValue, recordsData]);

  const viewDetailsHandler = id => {
    setSelectedTableId(id);
    fetchAppointmentById({
      variables: {
        apptId: id,
      },
    });
    fetchSlotByPractitionerId({
      variables: {
        practitionerId: '1669',
      },
    });
  };

  const heading = APPOINTMENT_SCHEDULE_DETAILS.HEADING;
  const detailsDate =
    dateParse_appointment(popUpData?.date ?? '') +
    ',' +
    ' ' +
    popUpData?.time +
    popUpData?.timeFormat;
  const cancelheading = APPOINTMENT_SCHEDULE_DETAILS.CANCEL;
  const viewDetailsClick = () => {
    setDrawerOpen(true);
    setIsOpen({
      successModalOpen: false,
      cancelModalOpen: false,
    });
    setShowPage(true);
  };

  useEffect(() => {
    return () => {
      setShowPage(false);
    };
  }, []);

  const question = APPOINTMENT_SCHEDULE_DETAILS.QUESTION;
  const description = APPOINTMENT_SCHEDULE_DETAILS.DESCRIPTION;

  const getFinalPopUpData = dateAndTime => {
    setPopUpData({
      startTime: dateAndTime?.startTime,
      endTime: dateAndTime?.endTime,
      date: `${dateAndTime.date}T${dateAndTime?.startTime?.slice(0, 8)}Z`,
      slotId: dateAndTime.slotId,
      appointmentId: selectedTableId,
    });
  };
  return (
    <Content>
      <BreadcrumbComponent
        breadcrumbData={breadcrumbData}></BreadcrumbComponent>
      <Typography variant="title">{APPOINTMENTS.TITLE_TEXT}</Typography>
      <Grid container direction="row" spacing={2} sx={{ mt: 2 }}>
        <Grid item>
          <ImageCardComponent
            image={appointmentsBanner?.image ?? doctor}
            alt={APPOINTMENTS.IMAGE_ALTERNATE_TEXT.DOCTOR}
            color={appointmentsBanner?.color ?? '#036FCB'}
            isVisible={
              upcomingAppointmentDate &&
              upcomingAppointmentDate !== DEFAULT_NULL_REPLACEMENT
            }>
            <JoinVisit
              color={getContrastYIQ('#036FCB')}
              date={upcomingAppointmentDate}
              provider={upcomingProvider}
              visitLink={null}
            />
          </ImageCardComponent>
        </Grid>
        <Grid item>
          <ImageCardComponent
            image={provider}
            alt={APPOINTMENTS.IMAGE_ALTERNATE_TEXT.PROVIDER}
            color="#ffffff">
            <ScheduleVisit
              color={getContrastYIQ('#ffffff')}
              description={APPOINTMENTS.DESCRIPTION_TEXT}
            />
          </ImageCardComponent>
        </Grid>
      </Grid>
      <Box sx={boxContainer}>
        <SearchBar
          sx={{
            width: '50%',
            minWidth: '250px',
            maxWidth: '500px',
            marginTop: '8px',
          }}
          onSearch={onSearch}
          placeholder={APPOINTMENTS.SEARCH_PLACEHOLDER_TEXT}
        />
        <FilterDropDown {...dateFilterOptions} filterType="Date:" />
        <FilterDropDown {...visitTypeFilterOptions} filterType="Visit type:" />
        <FilterDropDown {...statusFilterOptions} filterType="Status:" />
      </Box>
      <Box sx={table}>
        {!appointmentDetails.loading && !filteredData.length ? (
          <NotFound title={APPOINTMENTS.TITLE_TEXT} />
        ) : (
          <ReusableTable
            tableHeading={tableHeading}
            data={filteredData}
            viewDetailsHandler={viewDetailsHandler}
          />
        )}
      </Box>
      <BottomDrawerComponent
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        setShowPage={setShowPage}>
        {showpage ? (
          <AppointmentDetails
            providerName={appointmentDetails.providerName}
            providerDetails={appointmentDetails.providerDetails}
            visitDescription={appointmentDetails.visitDescription}
            visitReason={appointmentDetails.visitReason}
            dateTime={appointmentDetails.dateTime}
            visitLink={appointmentDetails.visitLink}
            medicalHistoryData={appointmentDetails.medicalHistoryData}
            amount={appointmentDetails.amount}
            paymentStatus={appointmentDetails.paymentStatus}
            paymentID={appointmentDetails.paymentID}
            appointmentStatus={appointmentDetails.appointmentStatus}
            setShowPage={setShowPage}
          />
        ) : (
          <AppointmentDetailsPage
            providerName={appointmentDetails.providerName}
            providerDetails={appointmentDetails.providerDetails}
            visitDescription={appointmentDetails.visitDescription}
            visitReason={appointmentDetails.visitReason}
            medicalHistoryData={appointmentDetails.medicalHistoryData}
            handleClickOpen={handleClickOpen}
            getFinalPopUpData={getFinalPopUpData}
            timeslot={timeslot}
            setShowPage={setShowPage}
          />
        )}
      </BottomDrawerComponent>
      <SimpleBackdrop
        open={
          allAppointments.loading ||
          fetchAppointmentByIdCall.loading ||
          upcomingAppointments.loading ||
          fetchSlotByPractitionerIdCall.loading
        }
      />

      <ConfirmationModal
        success
        open={isOpen.successModalOpen}
        onClose={handleClose}
        heading={heading}
        detailsDate={detailsDate}
        viewDetailsClick={viewDetailsClick}
        setShowPage={setShowPage}
      />

      <ConfirmationModal
        cancel
        open={isOpen.cancelModalOpen}
        onClose={handleClose}
        heading={cancelheading}
        detailsDate={detailsDate}
        title={question}
        description={description}
        setShowPage={setShowPage}
      />
    </Content>
  );
};
